// extracted by mini-css-extract-plugin
export var actions = "_dt-d";
export var benefitCard = "_dt-a";
export var benefitIcon = "_dt-b";
export var benefitLabel = "_dt-c";
export var benefits = "_dt-9";
export var bodyText = "_dt-8";
export var closeButton = "_dt-2";
export var content = "_dt-3";
export var eyebrow = "_dt-4";
export var heading = "_dt-5";
export var image = "_dt-f";
export var imagePanel = "_dt-e";
export var modal = "_dt-0";
export var shell = "_dt-1";
export var title = "_dt-6";
export var titleOffer = "_dt-7";